/* eslint-disable react/jsx-no-target-blank */
import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/yashgaur2503/" className='home__social-icon' target="_blank">
                <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://twitter.com/YashGaur9106539" className='home__social-icon' target="_blank">
                <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/in/yash-gaur-8671a1216/" className='home__social-icon' target="_blank">
            <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="https://github.com/THEYASHGAUR" className='home__social-icon' target="_blank">
            <i className="fa-brands fa-github"></i>
            </a>
            <a href="https://yashgaur.hashnode.dev/" className='home__social-icon' target="_blank">
                <i className="fa-brands fa-hashnode"></i>
            </a>
        </div>
    )
}

export default Social;
